module.exports = __webpack_public_path__ + "img/1.2229cd80.jpg";